import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=5aad6cae&scoped=true&"
import script from "./curriculum.vue?vue&type=script&lang=ts&"
export * from "./curriculum.vue?vue&type=script&lang=ts&"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=5aad6cae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad6cae",
  null
  
)

export default component.exports